export const formatPrice = (amount: number) => (amount / 100).toFixed(2);
